import React from "react";
import "./App.css";
import "materialize-css";
import {
  Button,
  Card,
  Row,
  Col,
  Slider,
  Slide,
  Caption,
  Footer,
  Modal,
} from "react-materialize";
import Home from "./components/Home.jsx";
import Nr1 from "./components/nr1.jsx";
import Nr2 from "./components/nr2.jsx";
import Nr3 from "./components/nr3.jsx";
import Contact from "./components/Contact";
import bg1 from "./components/svg/bg1.webp";
import DocumentMeta from "react-document-meta";

function App() {
  const meta = {
    title: "Hydraulik Kraków – Bogusław Wnęk | Wod-kan, Gaz, C.O. | Krowodrza",
    description:
      "Hydraulik Kraków – Bogusław Wnęk (P.P.H.U. EL-GAZ-WOD-TRANZ). Instalacje wod-kan, gazowe i c.o., usuwanie awarii, przeglądy. Krowodrza, Kraków i okolice. Tel: 789 807 598.",
    canonical: "https://hydraulikwnek.com/",
    meta: {
      charset: "utf-8",
      name: {
        keywords:
          "hydraulik Kraków, hydraulik Krowodrza, instalacje wod-kan Kraków, instalacje gazowe Kraków, centralne ogrzewanie Kraków, hydraulik awaria Kraków, hydraulik Wnęk, EL-GAZ-WOD-TRANZ, przegląd gazu Kraków, udrażnianie kanalizacji Kraków",
      },
    },
  };

  return (
    <DocumentMeta {...meta}>
      <div className="App">
        {/* Główny nagłówek H1 – niewidoczny wizualnie, istotny dla SEO */}
        <h1 className="sr-only" style={{ position: "absolute", left: "-9999px" }}>
          Hydraulik Kraków – Bogusław Wnęk – instalacje wod-kan, gazowe i c.o. Krowodrza i okolice
        </h1>

        <div className="">
          <Home />
        </div>

        <Slider
          className="z-depth-3 Slider"
          fullscreen={false}
          options={{
            duration: 500,
            height: 800,
            indicators: false,
            interval: 9000,
          }}
        >
          <Slide image={<img alt="Hydraulik Kraków – Bogusław Wnęk" width="100%" src={bg1} />}>
            <Caption className="" placement="center">
              <Card className="blue darken-3 bold">
                <div className="h3">Doświadczony hydraulik w Krakowie</div>
                <a
                  className="btn-large blue darken-3 z-depth-5 bold"
                  href="tel:+48789807598"
                >
                  <h6>tel: 789 807 598</h6>
                </a>
                <Row />
                <h5>
                  <div className="bold">Działam od 1996 roku, w Krakowie i okolicach</div>
                  <Row />
                  Instalacje wod-kan, c.o., gazowe – szeroki zakres robót
                  <Row />
                  Szybko i profesjonalnie, szerokie uprawnienia – od budowlanych po energetyczne
                </h5>
                Więcej informacji poniżej
              </Card>
            </Caption>
          </Slide>
          <Slide
            image={
              <img
                alt="Instalacje wodno-kanalizacyjne Kraków"
                width="100%"
                src="https://images.unsplash.com/photo-1517646287270-a5a9ca602e5c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80"
              />
            }
          >
            <Caption placement="center">
              <Card className="blue darken-3">
                <h2 className="white-text bold text-darken-2" style={{fontSize:"1.8rem"}}>
                  Instalacje wod-kan
                </h2>
                <a
                  className="btn-large blue darken-3 z-depth-5 bold"
                  href="tel:+48789807598"
                >
                  <h6>tel: 789 807 598</h6>
                </a>
                <h5 className="white-text text-darken-2">
                  Kompleksowe wykonywanie instalacji i przyłączy
                  <Row />
                  Udrażnianie instalacji
                  <Row />
                  Naprawy wycieków
                </h5>
                Więcej informacji poniżej
              </Card>
            </Caption>
          </Slide>
          <Slide
            image={
              <img
                alt="Instalacje centralnego ogrzewania Kraków"
                width="100%"
                src="https://images.unsplash.com/photo-1599028274511-e02a767949a3?ixlib=rb-1.2.1&auto=format&fit=crop&w=1471&q=80"
              />
            }
          >
            <Caption placement="center">
              <Card className="red">
                <h2 className="bold" style={{fontSize:"1.8rem"}}>Instalacje c.o.</h2>
                <a
                  className="btn-large red darken-3 z-depth-5 bold"
                  href="tel:+48789807598"
                >
                  <h6>tel: 789 807 598</h6>
                </a>
                <h5 className="white-text text-darken-2">
                  Wykonywanie kompleksowej instalacji c.o.
                  <Row />
                  Instalacje podłogowe
                  <Row />
                  Montaż kotłów gazowych
                </h5>
                Więcej informacji poniżej
              </Card>
            </Caption>
          </Slide>
          <Slide
            image={
              <img
                alt="Instalacje gazowe Kraków"
                src="https://images.unsplash.com/photo-1608454770647-01dc0f7dd97d?ixlib=rb-1.2.1&auto=format&fit=crop&w=1470&q=80"
              />
            }
          >
            <Caption placement="center">
              <Card className="orange darken-3">
                <h2 className="bold" style={{fontSize:"1.8rem"}}>Instalacje gazowe</h2>
                <a
                  className="btn-large orange darken-3 z-depth-5 bold"
                  href="tel:+48789807598"
                >
                  <h6>tel: 789 807 598</h6>
                </a>
                <h5 className="white-text text-darken-2">
                  Kompleksowe wykonywanie instalacji gazowych
                  <Row />
                  Naprawy i zmiany instalacji
                </h5>
                Więcej informacji poniżej
              </Card>
            </Caption>
          </Slide>
        </Slider>

        <Row />
        <a
          className="btn-large red awaria right-align bold z-depth-5 hide-on-small-only"
          href="tel:+48789807598"
        >
          AWARIA? ZADZWOŃ! tel: +48 789 807 598
        </a>

        <Row>
          <Col s={12} className="center">
            <h2>Usługi hydrauliczne – Kraków, Krowodrza i okolice</h2>
          </Col>
        </Row>

        <Nr1 />
        <Nr2 />
        <Nr3 />
        <Row />
        <Contact />

        <Footer
          className="blue darken-3"
          copyrights="© Choluj Design S.C."
          links={
            <ul>
              <li className="white-text" style={{ lineHeight: "2rem" }}>
                <strong>P.P.H.U. EL-GAZ-WOD-TRANZ</strong><br />
                Bogusław Wnęk<br />
                NIP: 677-113-66-05<br />
                ul. Piotra Stachiewicza 17, 31-303 Kraków<br />
                <a className="white-text" href="tel:+48789807598">Tel: 789 807 598</a><br />
                <a className="white-text" href="mailto:wnekhydraulika@gmail.com">wnekhydraulika@gmail.com</a>
              </li>
              <li style={{ marginTop: "1rem" }}>
                <Modal
                  actions={[
                    <Button flat modal="close" node="button" waves="green">
                      Zamknij
                    </Button>,
                  ]}
                  bottomSheet={false}
                  fixedFooter={false}
                  header="RODO"
                  id="Modal-footer"
                  open={false}
                  options={{
                    dismissible: true,
                    endingTop: "10%",
                    inDuration: 250,
                    onCloseEnd: null,
                    onCloseStart: null,
                    onOpenEnd: null,
                    onOpenStart: null,
                    opacity: 0.5,
                    outDuration: 250,
                    preventScrolling: true,
                    startingTop: "4%",
                  }}
                  trigger={
                    <Button className="blue darken-1" node="button">
                      RODO
                    </Button>
                  }
                >
                  <p>
                    Klauzula informacyjna dla klientów i kontrahentów. Zgodnie z przepisami rozporządzenia Parlamentu
                    Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. („RODO") informujemy, że
                    administratorem Państwa danych osobowych jest P.P.H.U. EL-GAZ-WOD-TRANZ Bogusław Wnęk.
                    Dane przetwarzane są w celu realizacji umów, obsługi zapytań oraz wypełnienia obowiązków prawnych.
                    Przysługuje Państwu prawo dostępu, sprostowania, usunięcia danych oraz wniesienia skargi do UODO.
                  </p>
                </Modal>
              </li>
            </ul>
          }
          moreLinks={
            <Button
              className="z-depth-5 blue darken-1"
              large
              target="_blank"
              node="a"
              href="https://cholujdesign.com"
            >
              CHD
            </Button>
          }
        >
          <h5 className="white-text">Hydraulik Kraków – Bogusław Wnęk</h5>
          <p className="grey-text text-lighten-3">
            Doświadczony hydraulik – Kraków, Krowodrza i okolice
          </p>
          <p className="grey-text text-lighten-4" style={{ fontSize: "0.85rem" }}>
            Instalacje wod-kan · instalacje gazowe · c.o. · awarie · przeglądy
          </p>
        </Footer>
      </div>
    </DocumentMeta>
  );
}

export default App;
